import { useToast as useNuxtToast } from "@nuxt/ui/composables";
import { useAuthenticatedUserStore } from "@/services/store";
import type { ToastArgs } from "./types";
import { toToast } from "./useToast";

/**
 * Forwards toasts dispatched through the Pinia `toastAdd` action (used by
 * non-component code like the http client via `globalToast`) to Nuxt UI's
 * toast system. Call once from App.vue setup; the $onAction subscription is
 * cleaned up automatically when the calling component unmounts.
 */
export function setupToastBridge() {
  const store = useAuthenticatedUserStore();
  const toast = useNuxtToast();

  store.$onAction((action) => {
    if (action.name === "toastAdd") {
      const [args] = action.args as [ToastArgs];
      toast.add(toToast(args.intent, args.message, { duration: args.displayTime }));
    }
  });
}
